import { LocalCacheManager } from "src/app/managers/local-cache.manager";
import { environment } from "src/environments/environment";

export abstract class EnvUtils {
    static get region(): string
    {
        if(this.regionSelectorVisible)
            return LocalCacheManager.region;

        LocalCacheManager.region = (environment['region'] ?? 'NA')
        return LocalCacheManager.region;
    }

    static set region(value: string)
    {
        if(!this.regionSelectorVisible)
            return;

        LocalCacheManager.region = value.toLocaleUpperCase();
    }

    static get isEuRegion(): boolean
    {
        return this.region == 'EU';
    }

    static get isUsRegion(): boolean
    {
        return this.region == 'NA';
    }

    private static get regionSelectorVisible(): boolean
    {
        return environment['regionSelector'] ?? false
    }
}